<template>
  <div class="upload" v-loading="loading">
    <div class="upload-bd">
      <div class="l">
        <div class="l-title">项目信息</div>
        <div class="l-content">
          <div class="l-list" v-for="(item, index) in info" :key="index">
            <div class="label">{{ item.label }}:</div>
            <div class="value">{{ item.value }}</div>
          </div>
        </div>
      </div>
      <div class="line"></div>
      <div class="r">
        <div class="r-hd">
          <v-upload @nowFile="nowFile" :fileType="['jpeg', 'jpg', 'png']">
            <div class="r-show">
              <img :src="imgBlob" v-if="imgBlob" />
              <div class="tips" v-else>点击选择交易凭证</div>
            </div>
          </v-upload>
        </div>
      </div>
    </div>
    <div
      class="upload-submit"
      :class="imgBlob === '' ? 'disabled' : ''"
      @click="submit"
    >
      提交凭证
    </div>
  </div>
</template>

<script>
import vUpload from "@/components/axios-uplaod-file/index";

export default {
  data() {
    return {
      file: null,
      imgBlob: "",
      aliFileUrl: "",
      loading: false,
      info: [
        {
          label: "项目名称",
          value: "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxx"
        },
        {
          label: "支付编号",
          value: "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxx"
        },
        {
          label: "订单申请时间",
          value: "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxx"
        },
        {
          label: "保函服务费",
          value: "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxx"
        },
        {
          label: "申请人",
          value: "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxx"
        },
        {
          label: "社会统一信用代码",
          value: "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxx"
        },
        {
          label: "投标登记号",
          value: "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxx"
        },
        {
          label: "担保金额",
          value: "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxx"
        },
        // {
        //   label: "标段名称",
        //   value: "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxx"
        // },
        {
          label: "标段编号",
          value: "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxx"
        },
        {
          label: "项目招标人",
          value: "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxx"
        },
        {
          label: "交易中心",
          value: "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxx"
        }
      ],
      submitParams: {}
    };
  },
  components: {
    vUpload
  },
  methods: {
    nowFile(file, blob, aliFileUrl) {
      console.log("当前选中文件==>", file);
      this.file = file;
      this.imgBlob = blob;
      this.aliFileUrl = aliFileUrl;
      this.submitParams.url = aliFileUrl;
    },
    submit() {
      if (this.imgBlob === "") return this.$message.warning("请上传凭证");
      this.loading = true;
      let params = {
        registerNumber: this.submitParams.registerNumber,
        url: this.submitParams.url,
        tradingPlatformCode: this.submitParams.tradingPlatformCode
      };
      this.$http
        .get("/ApplyInfo/saveAttachment", { params })
        .then(({ data: res }) => {
          if (res.status != 200) {
            return this.$message.error(res.msg);
          }
          console.log(res);
          this.$router.push({ name: "upLoadSuccess" });
        });
    },
    getInfo(params) {
      this.loading = true;
      this.$http
        .get("/ApplyInfo/objectMsgs", { params })
        .then(({ data: res }) => {
          console.log(res);
          if (res.status != 200) {
            let msgType = {
              403: "校验通过失败不允许查看项目信息",
              400: "未查询到项目信息"
            };
            return this.$message.error(msgType[res.status]);
          }
          if (res.data.guarantor != "3") {
            this.$router.push({ name: "gsdbResult" });
            return;
          }
          this.submitParams.registerNumber = params.registerNumber;
          this.submitParams.tradingPlatformName = res.data.tradingPlatformName;
          this.submitParams.tradingPlatformCode = res.data.tradingPlatformCode;

          this.info = [
            {
              label: "项目名称",
              value: res.data.blockName
            },
            {
              label: "支付编号",
              value: res.data.orderNo
            },
            {
              label: "订单申请时间",
              value: res.data.createTime
            },
            {
              label: "保函服务费",
              value: res.data.guaranteeFee
            },
            {
              label: "申请人",
              value: res.data.applyUser
            },
            {
              label: "社会统一信用代码",
              value: res.data.uniformCreditCode
            },
            {
              label: "投标登记号",
              value: res.data.registerNumber
            },
            {
              label: "担保金额",
              value: res.data.marginAmount
            },
            // {
            //   label: "标段名称",
            //   value: res.data.blockName
            // },
            {
              label: "标段编号",
              value: res.data.blockCode
            },
            {
              label: "项目招标人",
              value: res.data.projectTenderer
            },
            {
              label: "交易中心",
              value: res.data.tradingPlatformName
            }
          ];
          this.loading = false;
        })
        .catch(err => {
          console.error(err);
        });
    }
  },
  mounted() {
    let params = {
      registerNumber:
        this.$route.query.registerNumber || this.$route.params.registerNumber,
      sign: this.$route.query.sign || this.$route.params.sign
    };
    console.log("投标登记号==>", params.registerNumber);
    if (params.registerNumber) {
      this.getInfo(params);
    } else {
      this.loading = true;
      this.$message({
        message: "非法访问!",
        type: "error"
      });
    }
  }
};
</script>

<style lang="less" scoped="scoped">
.upload {
  border: 1px solid rgb(212, 212, 212);
  border-radius: 6px;
  box-shadow: 4.5px 4.5px 3.6px rgba(0, 0, 0, 0.014),
    12.5px 12.5px 10px rgba(0, 0, 0, 0.02),
    30.1px 30.1px 24.1px rgba(0, 0, 0, 0.026),
    100px 100px 80px rgba(0, 0, 0, 0.04);
  width: 1200px;
  margin: 0 auto 40px;
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  &-bd {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-bottom: 20px;
  }
  &-submit {
    font-size: 20px;
    padding: 10px 20px;
    background: #67c23a;
    color: #fff;
    border-radius: 4px;
    transition: 0.3s;
    cursor: pointer;
    &:hover {
      background: #67c23a6c;
    }
    &.disabled {
      background: #ccc;
      color: #fff;
      cursor: not-allowed;
    }
  }
}
.line {
  width: 1px;
  background: #d8d8d8;
  height: auto;
  margin: 0 20px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.22), 0px 0px 67px rgba(0, 0, 0, 0.44);
}
.l {
  &-title {
    font-size: 30px;
    letter-spacing: 1px;
    font-weight: bold;
    color: #007dff;
    margin-bottom: 20px;
    text-align: center;
  }
  &-content {
    font-size: 20px;
    width: 100%;
    color: #333;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 10px;
  }
  &-list {
    margin-bottom: 20px;
    .value {
      color: rgb(121, 121, 121);
    }
  }
}
.r {
  &-hd {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
  }
  &-show {
    position: relative;
    width: 400px;
    height: 400px;
    background: #eee;
    border-radius: 5px;
    overflow: hidden;
    box-shadow: 2.8px 2.8px 2.2px rgba(0, 0, 0, 0.02),
      6.7px 6.7px 5.3px rgba(0, 0, 0, 0.028),
      12.5px 12.5px 10px rgba(0, 0, 0, 0.035),
      22.3px 22.3px 17.9px rgba(0, 0, 0, 0.042),
      41.8px 41.8px 33.4px rgba(0, 0, 0, 0.05),
      100px 100px 80px rgba(0, 0, 0, 0.07);
    cursor: pointer;
    transition: 0.3s;
    &:hover {
      box-shadow: 4.5px 4.5px 3.6px rgba(0, 0, 0, 0.014),
        12.5px 12.5px 10px rgba(0, 0, 0, 0.02),
        30.1px 30.1px 24.1px rgba(0, 0, 0, 0.026),
        100px 100px 80px rgba(0, 0, 0, 0.04);
    }
    .tips {
      letter-spacing: 2px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: rgb(87, 87, 87);
      font-size: 20px;
      font-weight: bold;
    }
    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
